import React, { Component } from 'react'
import config from 'config'
import ReactDOM from 'react-dom'

export default class Page extends Component {
  constructor() {
    super()

    this.mountPromise = new Promise((resolve, reject) => {
      this.defer = {
        resolve: resolve,
        reject: reject
      }
    })

    this.state = {
      component: 'div',
      params: null
    }
  }

  componentDidUpdate(prevProps) {
    this.defer.resolve()
  }

  get component() {
    return this.state.component
  }

  setComponent(component, params, route, localized, main) {
    this.setState({
      component: component,
      params: params,
      route: route,
      localized: localized,
      main: main
    })

    return this.mountPromise
  }

  render() {
    return this.state.component ? (
      <this.state.component
        ref={el => {
          this.module = el
          this.el = ReactDOM.findDOMNode(el)
        }}
        {...this.state.localized}
        {...this.state.main}
      />
    ) : null
  }
}



// WEBPACK FOOTER //
// ./src/app/Page/index.js